const SITE_URL = 'https://gab.ai';

/**
 * Prefill for topic-page compliance feedback (revisions, takedowns, removals, etc.).
 */
export function buildTopicFeedbackPrefill({ topicName, topicSlug, pageUrl }) {
  const name = String(topicName || topicSlug || 'this topic').trim();
  const slug = String(topicSlug || '').trim();
  const url = String(pageUrl || '').trim()
    || (slug ? `${SITE_URL}/start/${encodeURIComponent(slug)}` : '');

  return [
    `Feedback about the topic page: ${name}`,
    url ? `Page: ${url}` : '',
    '',
    'Request type (revision, correction, update, removal, takedown, or other):',
    '',
    'Details:',
    '',
  ].join('\n');
}
